const masterSetup = {
  state: "state_id",
  business_state: "business_state_id",
  source: "source_id",
  country: "country_id",
  business_country: "business_country_id",
};

const header = [
  { id: "clientName", label: "Client Name" },
  { id: "businessName", label: "Business Name" },
  { id: "branchOffice", label: "Branch Office" },
  { id: "phone", label: "Phone" },
  { id: "sales", label: "Manager" },
  { id: "employee", label: "Employee" },
  { id: "action", label: "Action" },
];

/** New Clients Request table — one row per requested service. */
const requestHeader = [
  { id: "clientName", label: "Client Name" },
  { id: "serviceName", label: "Service Name" },
  { id: "businessName", label: "Business" },
  { id: "taxYear", label: "Tax Year" },
  { id: "serviceFrequency", label: "Service Frequency" },
  { id: "status", label: "Status" },
  { id: "sales", label: "Client Manager" },
  { id: "branchOffice", label: "Branch Office" },
  { id: "phone", label: "Phone" },
  { id: "lastUpdated", label: "Last Updated Date" },
  { id: "filedCopies", label: "Filed Copies" },
  { id: "action", label: "Action" },
];

export { masterSetup, header, requestHeader };
